<template>
  <div>
    <!-- 变更处理人 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="480px" center>
      <div class="rowBox">
        <!-- 人员选择 -->
        <div class="label">
          {{ $t('message.personnelSelection') }}:
        </div>
        <div class="val">
          <el-select v-model="datas.adminId" clearable onfocus="this.select()"
            :placeholder="$t('message.serviceOperator')" filterable>
            <el-option :label="item.realname" :value="item.id" v-for="(item) in adminList" :key="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="updateAdminId">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const MECHANICAL_OPERATOR = {
  id: 1377,
  username: 'P209',
  realname: '机器操作员',
  forbid_login: 0
}

export default {
  data() {
    return {
      // 删除数据
      datas: {},
      dialogVisible: false,
      adminList: [],
    };
  },
  methods: {
    // 服务单-变更
    updateAdminId() {
      this.$api.optionServiceApi.updateAdminId(this.datas).then((res) => {
        this.$message.success(res.msg)
        this.$parent.optionServiceList()
        this.dialogVisible = false
      });

    },
    usableAdminList() {
      //服务单-可选检品操作人员
      this.$api.optionServiceApi.usableAdminList().then(res => {
        // 机器操作员固定置顶，接口返回同一账号时不重复显示。
        this.adminList = [
          MECHANICAL_OPERATOR,
          ...res.data.filter(item => item.id != MECHANICAL_OPERATOR.id)
        ]
      })
    },

  }
}
</script>
<style lang='scss' scoped>
.rowBox {
  display: flex;
  margin: 20px 20px 0;

  .label {
    width: 100px;
    line-height: 40px;
  }

  .val {
    flex: 1;
  }
}
</style>
